import styled, { keyframes } from "styled-components";

const animateIcons = keyframes`
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
`;

export const HoverWindow = styled.div`
  min-width: 184px;
  max-width: 200px;
  background: #ffffffcc;
  padding: 10px 13px;
  position: fixed;
  pointer-events: auto;
  z-index: 999999;
  top: 30px;
  left: -103px;
  right: calc(50% - 152px);
  border-radius: 5px;

  .wrapper {
    word-wrap:break-word;
    position: relative;
    .max-hole-exceeded {
      color: #fa3c30;
    }
    .close-icon {
      position: absolute;
      right: -25px;
      top: -21px;
      cursor: pointer;
    }
    .arrow {
      width: 15px;
      height: 15px;
      background: linear-gradient(135deg, #ffffffcc 50%, transparent 50%);
      position: absolute;
      top: -17px;
      right: 0;
      left: 0;
      margin: 0 auto;
      transform: rotate(45deg);
    }
  }
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.8); */
  h3 {
    font-weight: 800;
    font-size: 25px;
    line-height: 29px;
    color: var(--text-primary);
    margin-bottom: 4px;
  }
  p {
    font-size: 16px;
    line-height: 23px;
    color: var(--text-primary);
    margin-bottom: 4px;
  }
  .date-and-time-max-hole-alert {
    font-size: 13px;
    line-height: 23px;
    background: #fa3c30;
    border-radius: 30px;
    color: var(--theme-text);
    padding: 0 10px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    display: flex;
  }
  .date-and-time {
    font-size: 11px;
    line-height: 23px;
    background: var(--club-car-gold-bg);
    border-radius: 30px;
    color: var(--theme-text);
    padding: 0 10px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    display: flex;
  }
  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      width: 30px;
      height: 30px;
      background: var(--input-background);
      border-radius: 6px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border: 1px solid var(--side-nav-btn-border-color);
      &.active {
        background: #bc9b6a;
        color: white;
      }
    }
  }
  .SignalIconCover {
    float: right;
    margin-right: 20px;
  }
  .carSignalIcon {
    display: flex;
  }

  &.for-top {
    top: unset;
    bottom: 55px;
    .wrapper {
      .arrow {
        top: unset;
        bottom: -17px;
        transform: rotate(225deg);
      }
    }
  }

  &.for-left {
    left: -265px;
    top: -100px;
    .wrapper {
      .arrow {
        left: unset;
        right: -20px;
        top: 84px;
        transform: rotate(135deg);
      }
    }
  }

  &.for-right {
    left: 40px;
    top: -100px;
    .wrapper {
      .arrow {
        left: -20px;
        right: unset;
        top: 84px;
        transform: rotate(315deg);
      }
    }
  }

  &.bottom-left {
    border-radius: 5px 0 5px 5px;
    left: unset;
    right: 36px;
    .wrapper {
      .close-icon {
        left: -29px;
        right: unset;
        top: -28px;
      }
      .arrow {
        right: -13px;
        left: unset;
        transform: rotate(90deg);
        top: -10px;
      }
    }
  }

  &.bottom-right {
    border-radius: 0 5px 5px 5px;
    right: unset;
    left: 36px;
    .wrapper {
      .arrow {
        left: -13px;
        right: unset;
        transform: rotate(0deg);
        top: -10px;
      }
    }
  }

  &.top-left {
    left: unset;
    right: 38px;
    top: unset;
    bottom: 21px;
    .wrapper {
      .arrow {
        top: unset;
        bottom: -10px;
        left: unset;
        right: -13px;
        transform: rotate(180deg);
      }
    }
  }

  &.top-right {
    left: 30px;
    right: unset;
    top: unset;
    bottom: 20px;
    .wrapper {
      .arrow {
        top: unset;
        bottom: -10px;
        left: -14px;
        right: unset;
        transform: rotate(272deg);
      }
    }
  }
`;

export const Marker = styled.div`
  svg {
    circle {
      fill: #fff;
    }
  }
`;
export const LocationWrapper = styled.div`
  position: relative;
  display: flex;
  .container1 {
    > div {
      button {
        background: #ffffff;
        border: 3px solid #fff;
        height: 34px;
        width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 40px;
        position: absolute;
        left: -18px;
        top: -30px;
        z-index: 2;
      }
      .box-section {
        padding: 0;
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        height: 28px;
        width: 60px;
        z-index: 1;
        position: relative;
        background: #1d1d1d;
        border: 1px solid var(--checkbox-bg);
        border-radius: 5px;
        font-family: "latobold";
        color: var(--checkbox-bg);
        font-size: 18px;
        left: 8px;
        top: -26px;
      }
    }
  }
`;
export const CarWrapper = styled.div`
  position: relative;
  display: flex;
  cursor: pointer;
  .tag-icon-specific-car {
    // border: 1px solid rgb(95, 158, 79) !important;
  }
  .car-icon {
    background: #ffffff;
    border: 3px solid #fff;
    height: 34px;
    width: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    position: absolute;
    left: -24px;
    z-index: 2;
  }
  .container {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 28px;
    z-index: 9999;
    position: absolute;
    left: -34px;
    top: -14px;
    border-radius: 5px;
    font-family: "latobold";
    .car-number {
      background: #1d1d1d;
      border: 1px solid var(--checkbox-bg);
      border-radius: 5px;
      z-index: 1;
    }
    &.pace-behind {
      border: 4px solid #eab52d;
      .car-number {
        h6 {
          color: #eab52d;
        }
      }
    }
    &.pace-critical {
      border: 4px solid #fa3c30;
      .car-number {
        h6 {
          color: #fa3c30;
        }
      }
    }
  }
  .zoom-in-out-box {
    animation: ${animateIcons} 1s ease infinite;
  }
  .car-number {
    font-size: 20px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding: 0 10px;
    font-weight: 700;
    gap: 7px;
    min-width: 60px;
    position: relative;
    .plus-icon {
      position: relative;
      top: 15px;
      display: inline-flex;
      width: 15px;
      height: 15px;
      border: 1px solid red;
      border-radius: 50%;
    }
    .icon-wrapper {
      display: flex;
    }
    h6 {
      color: var(--checkbox-bg);
      font-size: 18px;
      &.pace-behind {
        color: #eab52d;
      }
      &.pace-critical {
        color: #fa3c30;
      }
    }
  }
  .tag-car {
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 7px solid #000000;    
    z-index: 9;
    .car-number h6 {
      color: #fff;
    }
  }

  .not-communicating-car {
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 7px solid #fa3c30;    
    z-index: 9;
    .car-number h6 {
      color: #fff;
    }
  }

  .carPopup {
    transform: translate(-50%, -100%);
    border-radius: 6px;
    padding: 8px;
    white-space: nowrap;
  }
`;